export const ACTION_RESET = 'FETCH_MORESTORY_RESET';
export const ACTION_REQUEST = 'FETCH_MORESTORY_REQUEST';
export const ACTION_SUCCESS = 'FETCH_MORESTORY_SUCCESS';
export const ACTION_ERROR = 'FETCH_MORESTORY_ERROR';